import { CSSProperties } from '@mui/styles';
import AgButton from '../../AgButton';
import { useIntl } from 'react-intl';
import AgCustomFieldGroup, { CustomFields } from '../AgCustomFieldGroup';
import { ChangeEventHandler, Dispatch, SetStateAction, useEffect, useState } from 'react';
import AgTypography from '../../../Styles/AgTypography';
import { CustomFieldGroupProps } from '../../../../pages/MemberInfo/ProfileDetails/EditMemberDetails';
import {
  ApiEnumGroup,
  ApiItemData
} from '@agunity/api-v4/build/data-contracts';
import { HasOnBlurProps } from '../../../../pages/MemberInfo/AddMember/AddMember';

export interface AgMultipleCustomFieldData {
  title: string;
  fields: CustomFields[];
  editOnly?: boolean;
  onChange?: ChangeEventHandler;
  mainWidth?: CSSProperties['width'];
}

export interface AgMultipleCustomFieldProps {
  data?: AgMultipleCustomFieldData[];
  mainWidth?: CSSProperties['width'];
  // eslint-disable-next-line no-unused-vars
  setOrgData?: (data: ApiItemData[]) => void;
  customFieldGroupData?: CustomFieldGroupProps[];
  setPersonalDetails?: Dispatch<SetStateAction<any | undefined>>;
  identity?: any ;
  orgData?: ApiItemData[];
  setHasMemberProfileError?: Dispatch<SetStateAction<boolean>>;
  showMemberProfileError?: boolean;
  setHasPersonalDetailsError?: Dispatch<SetStateAction<boolean>>;
  showPersonalDetailsError?: boolean;
  enumList?: ApiEnumGroup[];
  hasOnBlur?: HasOnBlurProps;
  setHasOnBlur?: Dispatch<SetStateAction<HasOnBlurProps>>;
  // eslint-disable-next-line no-unused-vars
  setDetails?: (data: ApiItemData[]) => void;
  details?: ApiItemData[];
  showError?: boolean;
  // eslint-disable-next-line no-unused-vars
  setErrors?: (error: Record<string, boolean>) => void;
}

const AgMultipleCustomField = ({
  data = [],
  mainWidth,
  setOrgData,
  setPersonalDetails,
  orgData,
  identity,
  setHasMemberProfileError,
  showMemberProfileError,
  setHasPersonalDetailsError,
  showPersonalDetailsError,
  enumList,
  hasOnBlur,
  setHasOnBlur,
  setDetails,
  details,
  setErrors,
  showError = false
}: AgMultipleCustomFieldProps) => {
  const [expand, setExpand] = useState<boolean[]>(data.map(() => false));
  const [expandAll, setExpandAll] = useState<boolean>(false);
  const messages = useIntl().formatMessage;

  // todo code below are commented out due to mandatory level of custom field is still under discussion
  // const hasConditionalFieldNotEmpty = (fields: CustomFields[]) => {
  //   let result = false;
  //   fields.forEach(field => {
  //     if (field.mandatoryLevel === MANDATORY_LEVEL.Conditional && !isEmpty(field.value)) {
  //       result = true;
  //     }
  //   });
  //   return result;
  // };

  // useEffect(() => {
  //   if (setHasMemberProfileError) {
  //     let hasMemberProfileError = false;
  //     data.forEach(customField => {
  //       const hasConditionalFieldValue = hasConditionalFieldNotEmpty(customField.fields);
  //       customField.fields.forEach(item => {
  //         if (
  //           (item.mandatoryLevel === MANDATORY_LEVEL.Mandatory && isEmpty(item.value))
  //           || (item.mandatoryLevel === MANDATORY_LEVEL.Conditional && hasConditionalFieldValue && !isEmpty(item.value))
  //         ) {
  //           hasMemberProfileError= true;
  //         }
  //       });
  //     });
  //     setHasMemberProfileError(hasMemberProfileError);
  //   }
  //   if (setHasPersonalDetailsError) {
  //     let hasPersonalDetailsError = false;
  //     data?.forEach(customField => {
  //       const hasConditionalFieldValue = hasConditionalFieldNotEmpty(customField.fields);
  //       customField.fields.forEach(item => {
  //         if (
  //           (item.mandatoryLevel === MANDATORY_LEVEL.Mandatory && isEmpty(item.value))
  //           || (item.mandatoryLevel === MANDATORY_LEVEL.Conditional && hasConditionalFieldValue && isEmpty(item.value))
  //         ) {
  //           hasPersonalDetailsError = true;
  //         }
  //       });
  //     });
  //     setHasPersonalDetailsError(hasPersonalDetailsError);
  //   }
  // }, [data, setHasMemberProfileError, setHasPersonalDetailsError]);

  useEffect(() => {
    if (showError) {
      setExpandAll(true);
      setExpand(data.map(() => true));
    }
  }, [data, showError]);

  return (
    <AgTypography
      sx={{
        width: mainWidth ?? 'auto'
      }}
    >
      <AgTypography
        style={{
          display: 'flex',
          justifyContent: 'end'
        }}
      >
        <AgButton
          label={
            expandAll
              ? messages({ id: 'CLOSE_ALL' })
              : messages({ id: 'EXPAND_ALL' })
          }
          variant='outlined'
          onClick={() => {
            if (expandAll) {
              setExpandAll(false);
              setExpand(data.map(() => false));
            } else {
              setExpandAll(true);
              setExpand(data.map(() => true));
            }
          }}
          color='secondary'
        />
      </AgTypography>
      <AgTypography
        sx={{
          paddingTop: '15px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}
      >
        {data.map((customField, index) => (
          <AgCustomFieldGroup
            key={index}
            title={customField.title}
            fields={customField.fields}
            setOrgData={setOrgData}
            setPersonalDetails={setPersonalDetails}
            setData={setDetails}
            data={details}
            identity={identity}
            orgData={orgData}
            mainWidth={customField.mainWidth}
            editOnly={customField.editOnly}
            expandMain={expand[index]}
            setExpandMain={(expandMain: boolean) => {
              const newExpand = [...expand];
              newExpand[index] = expandMain;
              setExpand(newExpand);
              let expandOrCloseAll = true;
              newExpand.forEach((expand) => {
                // if all sub-customFields change the status, then reset the button 'all' on the top
                if (expand !== expandMain) {
                  expandOrCloseAll = false;
                  return;
                }
              });
              expandOrCloseAll && setExpandAll((prevState) => !prevState);
            }}
            setHasMemberProfileError={setHasMemberProfileError}
            showMemberProfileError={showMemberProfileError}
            setHasPersonalDetailsError={setHasPersonalDetailsError}
            showPersonalDetailsError={showPersonalDetailsError}
            enumList={enumList}
            hasOnBlur={hasOnBlur}
            setHasOnBlur={setHasOnBlur}
            setErrors={setErrors}
            showError={showError}
          />
        ))}
      </AgTypography>
    </AgTypography>
  );
};

export default AgMultipleCustomField;
